export default {
    methods: {
        userTypeLabel(_type) {
            if( !_type ) {
                return "";
            }
        
            if ( 'SystemUser' == _type ) {
                return "后台用户";
            }
        
            if ( 'TjkUser' == _type ) {
                return "淘金客";
            }
        
            if ( 'TicketTrigger' == _type ) {
                return "触发器";
            }
        
            if ( 'Department' == _type ) {
                return "用户组";
            }
        
            if ( 'Workflow' == _type ) {
                return "工作流";
            }
        
            return _type;
        },

        iconForUser ( _user ) {
            if ( 'SystemUser' == _user.type ) {
                return 'el-icon-s-check'; 
            }

            if ( 'TjkUser' == _user.type ) {
                return 'el-icon-s-custom'; 
            }

            return 'el-icon-user'; // el-icon-s-check // el-icon-s-custom // el-icon-user
        },

        userWithLabel( user ) {
            if ( !user ) {
                return user;
            }

            var loginName = user.loginName;
            if ( !loginName || 'null' == loginName) {
                loginName = user.id;
            }

            user.label = user.name + '(' + loginName + ') ' + this.userTypeLabel(user.type);

            return user;
        },

        // 用户 排重
        userDistinct_0(_users) {
            var _ids = [];

            return _users.filter(e => {
                if ( !e.id || '' == e.id ) {
                    return false; // 不要这个 因为没有ID
                }

                if (_ids.indexOf(e.id) > -1) {
                    return false; // 不要这个 因为重复
                }

                _ids.push(e.id); // 记录 避免重复
                return true; // 要这个
            });
        },

        tagDistinct( _tags ) {
            var _distinct = [];
            var filtered = _tags.filter(e => {
                if (_distinct.indexOf(e) > -1) {
                    return false;
                }

                _distinct.push(e);
                return true;
            });

            return filtered;
        },

        onUserUpdated() {
          var ccspans = $(this.$el).find(".el-tag--info .el-select__tags-text");
          $(ccspans).each((i, e)=>{
            var u = this.userWithLabel(this.valueData[i]);
            if ( !u ) { // 可能不是抄送是指派人的
                return true; // continue
            }

            $(e).html(u.label);
    
            u["_index"] = i + "/" + ccspans.length ;
            $(e).attr("title", JSON.stringify(u));
          });
        }
    }
}


// WEBPACK FOOTER //
// ./src/assets/mixins/MixinUserUtil.js